import { gql } from "@apollo/client";
import { createQuery } from "@mostrans/web-components/helpers/graphqlHelpers";

const GET_EMPLOYEE_DEMOGRAPHY = gql`
  query GetEmployeeDemography {
    getEmployeeDemography {
      data {
        id
        demography_cat_id
        demography_name
        value_type
        value
        create_date
        updated_date
        create_by
        update_by
        deleted_date
        category {
          id
          demography_cat_name
          create_date
          updated_date
          create_by
          update_by
          deleted_date
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getEmployeeDemography = createQuery({
  query: GET_EMPLOYEE_DEMOGRAPHY,
  defaultValue: [],
  initialVariables: {},
  selector: "getEmployeeDemography.data",
  responseSelector: "getEmployeeDemography.response",
});

const GET_EMPLOYEE_DEMOGRAPHY_ADMIN = gql`
  query GetEmployeeDemographyAdmin {
    getEmployeeDemographyAdmin {
      data {
        id
        demography_cat_id
        demography_name
        value_type
        value
        create_date
        updated_date
        create_by
        update_by
        deleted_date
        category {
          id
          demography_cat_name
          create_date
          updated_date
          create_by
          update_by
          deleted_date
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getEmployeeDemographyAdmin = createQuery({
  query: GET_EMPLOYEE_DEMOGRAPHY_ADMIN,
  defaultValue: [],
  initialVariables: {},
  selector: "getEmployeeDemographyAdmin.data",
  responseSelector: "getEmployeeDemographyAdmin.response",
});

const GET_DETAIL_EMPLOYEE_DEMOGRAPHY = gql`
  query GetDetailEmployeeDemography($getDetailEmployeeDemographyId: Int) {
    getDetailEmployeeDemography(id: $getDetailEmployeeDemographyId) {
      data {
        id
        demography_cat_id
        demography_name
        value_type
        value
        create_date
        updated_date
        create_by
        update_by
        deleted_date
        category {
          id
          demography_cat_name
          create_date
          updated_date
          create_by
          update_by
          deleted_date
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getDetailEmployeeDemography = createQuery({
  query: GET_DETAIL_EMPLOYEE_DEMOGRAPHY,
  defaultValue: null,
  initialVariables: { getDetailEmployeeDemographyId: null },
  selector: "getDetailEmployeeDemography.data",
  responseSelector: "getDetailEmployeeDemography.response",
});

const GET_DEMOGRAPHY_CATEGORY = gql`
  query GetDemographyCategory {
    getDemographyCategory {
      data {
        id
        demography_cat_name
        create_date
        updated_date
        create_by
        update_by
        deleted_date
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getDemographyCategory = createQuery({
  query: GET_DEMOGRAPHY_CATEGORY,
  defaultValue: [],
  initialVariables: {},
  selector: "getDemographyCategory.data",
  responseSelector: "getDemographyCategory.response",
});
